import type { ComponentType } from 'react';
import { WATERFALL_SLUG } from 'common/constants/allocations';
import {
  BREAKPOINT_ANALYSIS_SLUG,
  CAP_TABLE_SLUG,
  CASH_FLOW_LEDGER_SLUG,
  FUND_OWNERSHIP_SLUG,
} from 'common/constants/cap-table';
import { COMPANIES_SUMMARY_SLUG } from 'common/constants/companies';
import { DOCUMENT_GENERATION_JOBS_SLUG, DOCUMENTS_SLUG } from 'common/constants/documents';
import { FINANCIAL_SLUG } from 'common/constants/financials';
import { VALUATIONS_SLUG } from 'common/constants/valuations';
import { CapTableView } from 'pages/CapTable';
import DocumentGenerationJobs from 'pages/DocumentGenerationJobs';
import RequestDocumentsView from 'pages/Documents/RequestDocumentsView';
import FinancialPage from 'pages/Financials';
import { Portfolio as PortfolioView } from 'pages/Portfolio';
import { ValuationsAllocation as ValuationsAllocationView } from 'pages/ValuationsAllocation';
import WaterfallView from 'pages/Waterfall';

const COMPANY_ROUTE_VIEW_BY_SLUG: Record<string, ComponentType> = {
  [COMPANIES_SUMMARY_SLUG]: PortfolioView,
  [FINANCIAL_SLUG]: FinancialPage,
  [CAP_TABLE_SLUG]: CapTableView,
  [FUND_OWNERSHIP_SLUG]: CapTableView,
  [BREAKPOINT_ANALYSIS_SLUG]: CapTableView,
  [CASH_FLOW_LEDGER_SLUG]: CapTableView,
  [VALUATIONS_SLUG]: ValuationsAllocationView,
  [WATERFALL_SLUG]: WaterfallView,
  [DOCUMENTS_SLUG]: RequestDocumentsView,
  [DOCUMENT_GENERATION_JOBS_SLUG]: DocumentGenerationJobs,
};

const MissingCompanyRouteView = () => <p>Hello missing route</p>;

export const getCompanyRouteView = (tableSlug?: string) => {
  const CompanyRouteView = tableSlug ? COMPANY_ROUTE_VIEW_BY_SLUG[tableSlug] : undefined;

  return CompanyRouteView ? <CompanyRouteView /> : <MissingCompanyRouteView />;
};
